/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */

/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */
import { styled, type StyledProps } from '@compiled/react';

import { token } from '@atlaskit/tokens';
// eslint-disable-next-line import/order
import { dialogWidth, grid } from '@atlassian/search-dialog/style-utils';
// eslint-disable-next-line import/order
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIAnswerDefaultLoadingWrapper: ComponentType<
	{
		isReadingAids?: boolean;
	} & ClassAttributes<HTMLDivElement> &
		HTMLAttributes<HTMLDivElement> &
		StyledProps
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.div<{
	isReadingAids?: boolean;
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
}>(({ isReadingAids }) =>
	isReadingAids
		? `
        width: 100%;
				height: 92px;
        padding: ${token('space.300')};
        box-sizing: border-box;
      `
		: `
		${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
        width: ${dialogWidth};
		${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
        margin-top: ${grid.px};
        `,
);
